<template>
  <main class="campaign-extensions" :class="{ 'with-preview': !!selectedExtension }">
    <sb-async-dropdown
      class="extension-dropdown"
      :rows="extensionsDropdown.rows"
      :options="extensionsDropdown.options"
      :focused.sync="extensionsDropdown.focused"
      :disabled="selectedExtension"
      :selected="selectedExtension"
      @update:selected="clickedExtension"
    >
      <template #label>
        <template v-if="!selectedExtension">
          <span class="add-extension-label">+ add extension</span>
        </template>
        <template v-else>
          <a @click.stop="showingModal = selectedExtension.state" class="edit-extension">
            <span>{{ selectedExtension.state.label }}</span>
            <span class="edit-button">edit</span>
          </a>
          <a @click.stop="clickedCancel(selectedExtension.state)" class="delete-extension">&times;</a>
        </template>
      </template>
    </sb-async-dropdown>

    <template v-if="showingModal">
      <any-link-modal
        v-if="showingModal.type === 4"
        :campaign="campaign"
        :extension="showingModal"
        @resolve="didResolveModal"
        @reject="didRejectModal"
      />

      <bonus-points-modal
        v-if="showingModal.type === 5"
        :campaign="campaign"
        :extension="showingModal"
        @resolve="didResolveModal"
        @reject="didRejectModal"
      />

      <digital-voucher-modal
        v-if="showingModal.type === 1"
        :campaign="campaign"
        :extension="showingModal"
        @resolve="didResolveModal"
        @reject="didRejectModal"
        :error.sync="this.error"
      />

      <instant-points-modal
        v-if="showingModal.type === 6"
        :campaign="campaign"
        :extension="showingModal"
        @resolve="didResolveModal"
        @reject="didRejectModal"
      />

      <target-wallet-modal
        v-if="showingModal.type === 3"
        :extension="showingModal"
        @update:campaign="$emit('update:campaign', $event)"
        @resolve="didResolveModal"
        @reject="didRejectModal"
      />
    </template>
    <template v-if="selectedExtension">
      <any-link-preview
        v-if="selectedExtension.state.type === 4"
        :extension="selectedExtension.state"
      />

      <bonus-points-preview
        v-if="selectedExtension.state.type === 5"
        :extension="selectedExtension.state"
      />

      <digital-voucher-preview
        v-if="selectedExtension.state.type === 1"
        :extension="selectedExtension.state"
      />

      <instant-points-preview
        v-if="selectedExtension.state.type === 6"
        :payload="selectedExtension.state.payload"
      />

      <target-wallet-preview
        v-if="selectedExtension.state.type === 3"
        :extension="selectedExtension.state"
      />
    </template>
  </main>
</template>

<script>
import { campaignAPI } from "./../../../services/api/campaignAPI";
import { campaignRewardAPI } from "../../../services/api/campaignRewardAPI";
import AnyLinkModal from "./modals/any-link-modal";
import AnyLinkPreview from "./previews/any-link-preview";
import BonusPointsModal from "./modals/bonus-points-modal";
import BonusPointsPreview from "./previews/bonus-points-preview";
import DigitalVoucherModal from "./modals/digital-voucher-modal";
import DigitalVoucherPreview from "./previews/digital-voucher-preview";
import InstantPointsModal from "./modals/instant-points-modal";
import InstantPointsPreview from "./previews/instant-points-preview";
import TargetWalletModal from "./modals/target-wallet-modal";
import TargetWalletPreview from "./previews/target-wallet-preview";
import { rewardAPI } from '../../../services/api/rewardAPI';
import {UnexpectedError} from "@springbig/sb-components";

export default {
  props: {
    campaign: Object,
    refetchExtension: Boolean
  },

  name: "campaign-extensions",

  components: {
    AnyLinkModal,
    AnyLinkPreview,
    BonusPointsModal,
    BonusPointsPreview,
    DigitalVoucherModal,
    DigitalVoucherPreview,
    InstantPointsModal,
    InstantPointsPreview,
    TargetWalletModal,
    TargetWalletPreview
  },

  data: () => {
    return {
      anylinks: null,
      extensionsDropdown: {
        rows: [
          { slot: 'select-row',
            state: {
              type: 1,
              label: "digital voucher",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 5,
              label: "bonus points",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 6,
              label: "instant points",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 3,
              label: "target wallet",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 4,
              label: "any link",
              payload: null
            }
          }
        ],
        selected: null,
        focused: false,
        options: {
          label: () => {}
        }
      },
      reward: null,
      selectedExtension: null,
      hasPreloadImage: false,
      hasCouponImage: false,
      showingModal: null, //This hold the extension row we want to switch to
      error: null,
    }
  },

  created() {
    this.setReward();
  },

  methods: {
    async clickedCancel(_extension) {
      if(this.isReward(_extension)) {
        await rewardAPI.deleteReward(this.campaign.reward_id);
        this.reward = null;
        const extensionIndex = this.extensionsDropdown.rows.findIndex(item => item.state.label === _extension.label);
        this.extensionsDropdown.rows[extensionIndex].state.payload = null;
      }
      this.selectedExtension = null;
      this.$emit("updateStashboardPreviewExtension", null);
      this.$emit("update:campaign", { _type: 0 });
    },

    async setReward() {
      if(this.campaign.reward_id) {
        const { reward } = await campaignRewardAPI.fetch(this.campaign.reward_id, this.campaign.id, 'Campaign');
        this.reward = reward;

        await this.$store.dispatch('UPDATE_VALUES', { reward });
        await this.$store.dispatch('VALIDATE', ['reward']);
        await this.$store.dispatch('TOUCH_FIELDS', ['reward']);
      }
      this.anylinks = await campaignAPI.getAnyLinks(this.campaign.id);
      const extensionType = this.campaign.extension_type;
      if(extensionType !== 0) {
        this.selectedExtension = this.extensionsDropdown.rows.find(extension => extension.state.type === extensionType);
        this.selectedExtension.state.payload = this.getPayload(this.selectedExtension.state);
        this.$emit("updateStashboardPreviewExtension", this.selectedExtension.state);
      }
    },

    async clickedExtension(_newExtension) {
      if(!this.campaign.reward_id && this.isReward(_newExtension)) {
        const { reward } = await campaignRewardAPI.create(this.campaign.id, "Campaign");
        this.reward = reward;
        this.campaign.reward_id = reward.id;
      }

      const newExtension = { ..._newExtension }; //We make a copy since we add the payload to it later but use the payload for criteria in workflow

      if(this.shouldShowModal(newExtension)) {
        newExtension.payload = this.getPayload(newExtension);
        this.showingModal = newExtension;
      } else {
        this.selectedExtension = this.extensionsDropdown.rows.find(extension => extension.state.type === newExtension.type);

        if(this.selectedExtension.state.label === "digital voucher" || this.selectedExtension.state.label === "bonus points") {
          this.selectedExtension.state.payload.has_preload_image = this.hasPreloadImage
        }


        if(this.isReward(newExtension)){
          this.updateReward(newExtension.payload);
        }

        this.$emit("updateStashboardPreviewExtension", newExtension);
        this.$emit("update:campaign", { _type: newExtension.type });
      }
    },

    async didResolveModal(extension) {
      if(this.isReward(extension)){
        await this.updateReward(extension);
      }

      if (!this.error) {
        this.selectedExtension = this.extensionsDropdown.rows.find(extension => extension.state.type === this.showingModal.type);
        this.selectedExtension.state.payload = extension.payload;
        this.showingModal = null;
        this.$emit("updateStashboardPreviewExtension", this.selectedExtension.state);
        this.$emit("update:campaign", { _type: this.selectedExtension.state.type });
      }
      if(this.isReward(extension)){
        await this.setReward()
      }
    },

    didRejectModal() {
      this.showingModal = null;
      this.error = null
      this.$store.dispatch('DISMISS_ERRORS', { type: UnexpectedError })
    },

    async updateReward(extension) {
      const payload = {
        owner_id: this.campaign.id,
        owner_type: "Campaign",
        reward: extension.payload,
      }
      let reward = {}
      try {
        const response = await campaignRewardAPI.patchRewards(this.campaign.reward_id, payload);
        reward = response.reward
        this.error = null
      } catch (error) {
        reward = error.response.data?.reward
        this.error = error.response.data?.reward?.error
      }
      await this.$store.dispatch('UPDATE_VALUES', { reward });
      await this.$store.dispatch('VALIDATE', ['reward', 'send_at_local']);
    },

    isReward(extension) {
      return ["digital voucher", "bonus points", "instant points"].includes(extension.label);
    },

    getPayload(extension){
      if(this.isReward(extension)) {
        return this.reward;
      } else if(extension.label === "target wallet"){
        return {'target_wallet': this.campaign.wallet_target};
      } else if(extension.label === "any link"){
        return this.anylinks;
      }
    },

    shouldResetExtension(selectedExtension){
      if(this.isReward(selectedExtension) && !selectedExtension.payload?.item_name) {
        return true;
      } else if(selectedExtension.label === "any link" && selectedExtension.payload?.length === 0) {
        return true;
      } else if(selectedExtension.label === "target wallet" && !selectedExtension.payload?.target_wallet) {
        return true;
      }
      return false;
    },

    shouldShowModal(newExtension) {
      if(!newExtension) {
        return false;
      }else{
        return (this.isReward(newExtension) && !newExtension.payload) ||
               (newExtension.label === "any link" && (!Array.isArray(newExtension.payload) || newExtension.payload.length === 0)) ||
               (newExtension.label === "target wallet" && !newExtension.payload?.target_wallet)
      }
    },
  },
  watch: {
    refetchExtension(value) {
      if(value) {
        this.setReward();
        this.$emit('update:refetch-extension', false);
      }
    }
  }
}
</script>

<style scoped>
.campaign-extensions {
  background-color: white;
  display: flex;
  flex-flow: row nowrap;
  font-family: "AileronLight";
  margin-top: 20px;
  position: relative;
}

.add-extension-label {
  font-family: AileronThin;
}

.campaign-extensions.with-preview {
  border: 1px solid #128ff9;
  border-left: 0;
  border-radius: 16px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.extension-dropdown {
  margin-bottom: 0;
  width: 175px;
  border-radius: 16px 0 0 16px;
}

.campaign-extensions .extension-dropdown >>> .label-container {
  align-items: center;
  background-color: #128ff9;
  border-radius: inherit;
  color: white;
  display: flex;
  font-size: 18px;
  min-height: 100px;
  height: 100%;
  justify-content: center;
  min-width: 153px;
}
.campaign-extensions .extension-dropdown:last-child {
  border-radius: 16px;
}
.campaign-extensions .extension-dropdown >>> .sb-content {
  text-align: center;
  color: #128ff9;
  border-width: 0px 1px 1px 1px;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
  border-style: solid;
  border-color: #128ff9;
  margin-top: -15px;
  padding: 15px 0 0 0;
  background-color: transparent;
}

.campaign-extensions .extension-dropdown >>> .sb-footer {
  padding: 0;
}

.campaign-extensions .extension-dropdown >>> .sb-content-items {
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
}

.campaign-extensions .extension-dropdown >>> .sb-content-items .dropdown-item:last-of-type{
  padding-bottom: 15px;
}

.campaign-extensions .extension-dropdown .delete-extension {
  position: absolute;
  top: 0;
  left: 5px;
  font-size: 1.125em;
}

.campaign-extensions .extension-dropdown .edit-extension {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.campaign-extensions .extension-dropdown .edit-extension span {
  display: block;
  line-height: 20px;
  text-align: center;
}

.campaign-extensions .extension-dropdown .edit-button {
  font-size: .83em;
}

.campaign-extensions .extension-dropdown a {
  color: white;
}

.campaign-extensions .extension-dropdown .icon-container {
  display: none;
}

.campaign-extensions .extension-dropdown >>> .sb-content-items .select-row {
  font-size: 18px;
}

@media only screen and (max-width: 1023px) {
  .campaign-extensions .extension-dropdown >>> .label-container {
    min-width: unset;
    padding: 5px 2px;
  }
  .campaign-extensions .extension-dropdown >>> .sb-content-items .select-row {
    padding: 3px 2px;
  }
}
</style>
